<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Регистрация</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form @submit.prevent="reg">
                <v-text-field v-model="regdata.Email" label="Email" name="Email" prepend-icon="mdi-email" type="text" />
                <v-text-field v-model="regdata.password" type="password" label="Пароль" prepend-icon="mdi-lock"/>
                <v-text-field v-model="regdata.FIO" label="Фамилия И.О." name="FIO" prepend-icon="mdi-account" type="text" />
                <v-text-field v-model="regdata.Phone" label="Телефон" prepend-icon="mdi-card-account-phone" name="Phone" type="text" />
                <v-text-field v-model="regdata.Address" type="text" prepend-icon="mdi-target" label="Адрес" name="Address"/>
              </v-form>
            </v-card-text>
            <v-card-actions>
                <v-row align-center justify="center">
                <v-btn color="success" align-center justify-center @click.prevent="reg">Регистрация</v-btn>
                </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import LoginService from '../api-services/login.services'
export default {
  data(){
    return{
      regdata:{}
    };
  },
  components: LoginService,
  methods:{
    reg(){
      try{
        LoginService.reg(this.regdata)
        this.$router.push("/login")
      }
      catch(e){ }
    }
  }
}
</script>